/*
 * Rabatt-Feld im Warenkorb immer offen, wie bei Pammys. Stand 12.09.2026.
 * Gehoert zusammen mit assets/kokoro-rabatt.css.
 *
 * Das Theme setzt auf den zugeklappten Rabatt-Bereich das Attribut inert.
 * Solange es gesetzt ist, kann man das Feld weder antippen noch beschreiben,
 * auch wenn es per CSS sichtbar ist. Dieses Skript entfernt es.
 *
 * Der Warenkorb wird nach jeder Aenderung neu aufgebaut, zum Beispiel nach
 * Anwenden eines Codes. Der Beobachter oeffnet den Bereich danach wieder.
 * Keine Endlosschleife: nach dem Entfernen findet die Suche nichts mehr.
 */
(function () {
  function kokoroRabattOffen() {
    document.querySelectorAll('.cart-discount .disclosure-content[inert]').forEach(function (el) {
      el.removeAttribute('inert');
    });
    document.querySelectorAll('.cart-discount__input').forEach(function (i) {
      if (i.placeholder !== 'Gutscheincode') i.placeholder = 'Gutscheincode';
    });
  }

  kokoroRabattOffen();
  new MutationObserver(kokoroRabattOffen).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['inert'],
  });
})();
